import { makeStyles } from "tss-react/mui";
import { MiActions, MiCheckbox, MiChip, MiIcon } from "@miplatform/components";
import {
  BUTTON_VARIANTS,
  ICONS_WEB,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { MaterialCard } from "../../../../../components/MaterialCard/MaterialCard";

export const MaterialResultCard = ({
  material,
  selectedItems,
  setSelectedItems,
  checkedAreas,
  handleAddItemToAreas,
  setIsSuppliedByBuilder,
  isSuppliedByBuilder,
  planAreas,
  handleCheckArea,
}) => {
  const isSelected = selectedItems?.id === material.id;

  const handleCardClick = () => {
    if (isSelected) {
      return;
    }
    if (isSuppliedByBuilder) {
      setIsSuppliedByBuilder(false);
    }
    setSelectedItems(material);
  };

  return (
    <>
      <MaterialCard
        item={material}
        isSelected={isSelected}
        onClickCard={handleCardClick}
        rightAction={
          isSelected && (
            <MiCheckbox
              label="Builder Supplied"
              handleChange={(e) => setIsSuppliedByBuilder(e.target.checked)}
              value={isSuppliedByBuilder}
            />
          )
        }
      />
      {isSelected && (
        <BulkApplyCard
          checkedAreas={checkedAreas}
          planAreas={planAreas}
          handleCheckArea={handleCheckArea}
          handleCancelItem={() => setSelectedItems(null)}
          handleAddItemToAreas={handleAddItemToAreas}
        />
      )}
    </>
  );
};

const BulkApplyCard = ({
  checkedAreas,
  planAreas,
  handleCheckArea,
  handleCancelItem,
  handleAddItemToAreas,
}) => {
  const { classes, theme } = useStyles();

  const isAreaSelected = (area) => checkedAreas.some((c) => c.id === area.id);

  return (
    <Box className={classes.bulkApplyCard}>
      <Box className={classes.bulkApplyTitle}>
        <MiIcon
          path={mdi[ICONS_WEB.HELP_CIRCLE_OUTLINE]}
          color={theme.palette.white.main}
          className={classes.icon}
        />
        <Typography fontWeight={theme.fontWeight.semiBold}>
          Bulk Apply
        </Typography>
      </Box>
      <Typography variant={TYPOGRAPHY_VARIANTS.SUBTITLE2} color="grey.main">
        If you would like to apply this item to multiple areas, please select
        them below and select &quot;Add to Area(s)&quot;
      </Typography>
      <Box className={classes.chipContainer}>
        {planAreas.map((area) => {
          const isSelected = isAreaSelected(area);
          return (
            <MiChip
              key={area.id}
              label={area.label}
              size="small"
              variant={isSelected ? "filled" : "outlined"}
              color="primary"
              onClick={() => handleCheckArea(area, !isSelected)}
              clickable
            />
          );
        })}
      </Box>
      <Box className={classes.actionsContainer}>
        <MiActions
          actions={[
            {
              name: "Cancel",
              size: "small",
              variant: BUTTON_VARIANTS.TEXT,
              onClick: handleCancelItem,
              className: classes.cancelBtn,
            },
            {
              name: "Add to Area(s)",
              size: "small",
              variant: BUTTON_VARIANTS.CONTAINED,
              onClick: handleAddItemToAreas,
              disabled: !checkedAreas.length,
            },
          ]}
        />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  bulkApplyCard: {
    padding: theme.spacing(2),
    borderRadius: "0 0 4px 4px",
    backgroundColor: theme.palette.orange.light,
  },
  bulkApplyTitle: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  icon: {
    borderRadius: 4,
    backgroundColor: theme.palette.orange.medium,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5),
  },
  chipContainer: {
    display: "flex",
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0, 2, 0),
    flexWrap: "wrap",
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
  cancelBtn: {
    color: theme.palette.black.main,
    fontWeight: theme.fontWeight.semiBold,
  },
}));
